(function ($) {
	class W4D_FormBuilder {
		constructor() {
			this.initValidation();
		}

		initValidation() {
			const $forms = $('form[id^="w4d-fb-"]');
			const $submitBtn = $forms.find('button[type="submit"]');

			if (!$forms || !$forms.length) return;

			W4D_FrontendHelper.startButtonCountdownUntilEnabled($submitBtn, 9);

			const self = this;

			$forms.each(function () {
				const $form = $(this);

				$form.validate({
					submitHandler(form) {
						if (!W4D_FrontendHelper.checkHoneypot($form)) {
							return;
						}

						self.handleSubmitForm(form);
					},
				});
			});
		}

		handleSubmitForm(form) {
			const $form = $(form);
			const formId = $form.attr('id');
			const shortId = formId.replace('w4d-fb-', '');

			const fd = new FormData(form);
			fd.append('action', 'w4d_handle_fb_submit');
			fd.append('form-id', shortId);
			fd.append('nonce', w4d_frontend_ajax.nonce);

			const $submitBtn = $form.find('button[type="submit"]');
			const originalBtnText = $submitBtn.text();
			$submitBtn.prop('disabled', true).text('Šalje se...');

			$form.find('input[type="file"]').each(function () {
				const files = window.W4D_FileStore.get(this) || [];
				files.forEach((file) => {
					fd.append('attachments[]', file, file.name);
				});
			});

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				type: 'POST',
				data: fd,
				processData: false,
				contentType: false,
				success: (response) => {
					if (response.success) {
						$form.html(response.data.success_html);

						$('html, body').animate(
							{
								scrollTop: $form.offset().top - 50,
							},
							500
						);
					} else {
						W4D_Toast.showToast('error', response.data.message || 'Greška pri slanju forme.');
					}
				},
				error: (xhr, status, error) => {
					console.error('Form submit error:', error);
					W4D_Toast.showToast('error', 'Došlo je do greške pri slanju. Pokušajte ponovno.');
				},
				complete: () => {
					$submitBtn.prop('disabled', false).text(originalBtnText);
				},
			});
		}
	}

	$(document).ready(function () {
		window.W4D_FormBuilder = new W4D_FormBuilder();
	});
})(jQuery);
